module.exports = __webpack_public_path__ + "static/media/autopay_enabled.a5b97036.svg";